<template>
  <div>
    <div @click="$emit('close')"></div>
    <div class="modal-wrapper">
      <div class="modal-container" :style="{ width: width }">
        <div class="modal-header">
          {{ title }}
        </div>

        <div class="modal-body">
          <slot name="body"> default body </slot>
        </div>
        <div class="modal-footer">
          <button class="modal-cancel-button" @click="$emit('close')">
            {{ cancelButtonText }}
          </button>
          <button
            v-if="showOkButton"
            class="modal-ok-button"
            @click="$emit('ok')"
          >
            {{ okButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '500px'
    },
    title: {
      type: String,
      default: 'Modal'
    },
    okButtonText: {
      type: String,
      default: 'OK'
    },
    showOkButton: {
      type: Boolean,
      default: true
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel'
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  position: absolute;
  top: calc(50% - 239px);
  left: calc(50% - 254px);
  display: flex;
  flex-flow: column nowrap;
  margin: 0;
  padding: 24px;
  z-index: 15;
}

.modal-container {
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header {
  color: #66b015;
  text-align: left;
  font-size: 16px;
  font-weight: 900;
}

.modal-footer {
  text-align: right;
}

.modal-cancel-button {
  border: 1px solid #767675;
  background: #ffffff;
  border-radius: 4px;
  line-height: 48px;
  width: 176px;
  font-style: normal;
  margin-right: 20px;
  font-weight: normal;
  font-size: 14px;
  color: #767675;
  cursor: pointer;
}

.modal-ok-button {
  border: 1px solid #66b015;
  background: #66b015;
  border-radius: 4px;
  line-height: 48px;
  width: 176px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
